<script>
import Base from '@/plans/ZOOM_ROOMS/config/base';
import addonMixin from '@/plans/mx/addon';
import { mapGetters } from 'vuex';
import { dateTimeFormat } from '@/utils/dateformat.js';
import { AUDIO_SUB_TYPES, DEFAULT_MIN_HOST, planTypes } from '@/common/constants';
import { validDownSellLicense } from '@/utils/validate-downsell';
import audioUsCaMixin from '@/common/mixin/audio-us-ca-mixin';
import { flowTypes } from '@/common/service/page-config';

export default {
  extends: Base,
  mixins: [addonMixin, audioUsCaMixin],
  data() {
    return {
      showCycleAlert: true,
      showBoughtLicense: true,
    };
  },
  computed: {
    ...mapGetters(['basicConfig', 'currentEditPlan', 'boughtPlans']),
    disabledForBulkLicense() {
      return (cycle) => {
        return this.basicConfig?.isBulkLicenseAccount && this.currentEditPlan?.billing_cycle !== cycle;
      };
    },
    previousQuantity() {
      return this.currentEditPlan?.cartInfo?.selected_number ?? DEFAULT_MIN_HOST;
    },
    minHosts() {
      if (this.disableDownSell || !this.isStandardPrice) return this.previousQuantity;
      return this.mx_minHosts;
    },
    maxHosts() {
      const editMaxQuantity = 9999;
      const quantity = this.currentEditPlan?.cartInfo?.selected_number;
      return quantity <= editMaxQuantity ? editMaxQuantity : quantity;
    },
    hasNotStandardPriceUnlimitedAudioPlan() {
      return this.boughtPlans.some(item => item.type === planTypes.TOLLFREE && item.category === AUDIO_SUB_TYPES.UNLIMITED && item.isStandardPrice === false);
    },
    isStandardPrice() {
      const isEditFlow = this.$context.flow === flowTypes.edit;
      return (isEditFlow && !this.hasAccountDiscount) ? (this.currentEditPlan?.isStandardPrice && !this.hasNotStandardPriceUnlimitedAudioPlan) : true;
    },
    disableDownSell(){
      return this.basicConfig.downSellData.disableDownSell;
    },
    decreaseTips() {
      if (this.selectedNumber === this.previousQuantity && this.disableDownSell) {
        return this.$t('billing.error.can_not_bought_plan_tips');
      }

      if (this.selectedNumber <= this.minHosts) {
        return this.mx_decreaseTips || this.forNonStandardPriceTips;
      }

      return '';
    },
  },
  watch: {
    selectedNumber: {
      immediate: true,
      handler(license) {
        const {
          assignLicenseQuantity = 0,
          needAssignQuantity = 0,
          planExpireTime,
        } = validDownSellLicense({ quantity: license });
        if (needAssignQuantity > 0) {
          this.mx_licenseAlert = this.$t('billing.zr.remove_assigned_license', [
            assignLicenseQuantity,
            needAssignQuantity,
            dateTimeFormat(planExpireTime),
          ]);
        } else {
          this.mx_licenseAlert = '';
        }
      },
    },
  },
};
</script>
